
import { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Container, Button } from 'react-bootstrap';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { FaShieldAlt, FaConciergeBell, FaIndustry, FaUsersCog } from "react-icons/fa";
import LogoHeader from '../Assets/Images/samashreeenterprises.png';
import '../Assets/Css/webheader.css';
import { MdMarkEmailRead } from "react-icons/md";
import { FaPhoneSquareAlt } from "react-icons/fa";
import { FaHome, FaInfoCircle, FaPhoneAlt, FaTools } from "react-icons/fa";
import { GiBrickWall, GiPaintRoller , GiPlantSeed} from "react-icons/gi";
import { FaAngleDown } from "react-icons/fa";
import { MdFormatPaint } from "react-icons/md";
import { BiCalendarCheck } from 'react-icons/bi';


function WebHeader() {
  const [showSidebar, setShowSidebar] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const handleClose = () => setShowSidebar(false);
  const handleShow = () => setShowSidebar(true);

  const handleNavClick = () => {
    setExpanded(false); // Collapse navbar on link click
  };
  const location = useLocation();
  const isServicesActive = location.pathname.startsWith('/services') ||
    location.pathname === '/security' ||
    location.pathname === '/hospitality' ||
    location.pathname === '/construction' ||
    location.pathname === '/maintenance' ||
    location.pathname === '/construction' ||
    location.pathname === '/fabrication';
  const [showDropdown, setShowDropdown] = useState(false);



  const handleToggleManually = (e) => {
    e.preventDefault(); // stop default toggle behavior
    setShowDropdown(!showDropdown);
  };



  const handleMouseEnter = () => setShowDropdown(true);
  const handleMouseLeave = () => setShowDropdown(false);

  return (
    <>


      <div className="top-header">
        <Container className="d-flex flex-column flex-md-row justify-content-between align-items-center">
          <div className="d-flex flex-wrap align-items-center email-info">
            <a
              href="https://wa.me/7410596426"
              target="_blank"
              rel="noopener noreferrer"
              className="d-flex text-white align-items-center gap-2"
              style={{ textDecoration: 'none' }}
            >
              <FaPhoneSquareAlt className="d-none d-md-flex" />
              +917410596426
            </a>
            <span className="mx-2 text-white">|</span>
            <a
              href="mailto:info@samashreeenterprises.com"
              className="d-flex text-white align-items-center gap-2"
              style={{ textDecoration: 'none' }}
            >
              <MdMarkEmailRead className="d-none d-md-flex" />
              info@samashreeenterprises.com
            </a>
          </div>

          <div className="d-none d-md-flex mt-2 mt-md-0">
            <Button
              className="servicesbtn"
              size="sm"
              variant="primary"
              href="/security"
              style={{
                padding: '4px 10px',
                fontSize: '14px',
                borderRadius: '5px',
                backgroundColor: '#28326E',
                border: 'none',
              }}
            >
              Our Services
            </Button>
          </div>
        </Container>
      </div>


      {/* Main Navbar */}
      <Navbar expand="lg" className="custom-navbar">
        <Container className="d-flex justify-content-between align-items-center">
          {/* Logo only visible on mobile (hidden on desktop) */}
          <Navbar.Brand href='/' >
            <img src={LogoHeader} alt="Logo" className="navbar-logo" />
          </Navbar.Brand>

          {/* Toggle button only visible on mobile */}
          <Navbar.Toggle aria-controls="offcanvasNavbar" onClick={handleShow} className="d-lg-none" />

          {/* Main Nav visible only on desktop */}
          <Navbar.Collapse id="basic-navbar-nav" className="justify-content-center d-none d-lg-flex">
            <Nav>
              <Nav.Link as={NavLink} to="/" onClick={handleClose}>Home</Nav.Link>
              <Nav.Link as={NavLink} to="/aboutus" onClick={handleClose}>About Us</Nav.Link>

             
              <NavDropdown
                title={
                  <span className="nav-dropdown-toggle" style={{ display: 'flex', alignItems: 'center', gap: '5px', position: 'relative' }}>
                    Services <FaAngleDown style={{ fontSize: '0.7rem' }} />
                  </span>
                }
                id="services-nav-dropdown"
                className={isServicesActive ? 'active' : ''}
                show={showDropdown}
                onClick={handleToggleManually}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >

                <NavDropdown.Item as={NavLink} to="/fabrication">
                  <FaIndustry style={{ marginRight: "8px" }} />
                  Fabrication & Erection
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/security">
                  <FaShieldAlt style={{ marginRight: "8px" }} />
                  Security & Housekeeping
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/manpowerservice">
                  <FaUsersCog style={{ marginRight: "8px" }} />
                  Manpower Services
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/marklineservice">
                  < MdFormatPaint style={{ marginRight: "8px" }} />
                  Mark Line Services
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/construction">
                  <GiBrickWall style={{ marginRight: "8px" }} />
                  Civil Construction
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/maintenance">
                  <FaTools style={{ marginRight: "8px" }} />
                  Routine Maintenance
                </NavDropdown.Item>
                  <NavDropdown.Item as={NavLink} to="/KNGPage">
                  < GiPlantSeed style={{ marginRight: "8px" }} />
                  Nursery & Landscaping Services
                </NavDropdown.Item>
              </NavDropdown>
                <Nav.Link as={NavLink} to="/teamandmachinery" onClick={handleClose}>Team & Machineries </Nav.Link>

              <Nav.Link as={NavLink} to="/contact" onClick={handleClose}>Contact Us</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Offcanvas Sidebar for mobile */}
      <Offcanvas show={showSidebar}
        onHide={handleClose} placement="start"
        className="custom-offcanvas">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <a href="/">
              <img src={LogoHeader} alt="Logo" className="navbar-logo" />
            </a>
          </Offcanvas.Title>

        </Offcanvas.Header>
        <Offcanvas.Body className='offcanvasbody'>
          <Nav className="flex-column">
            <Nav.Link as={NavLink} to="/" onClick={handleClose}>
              <FaHome size={18} className="me-2" /> Home
            </Nav.Link>
            <Nav.Link as={NavLink} to="/aboutus" onClick={handleClose}>
              <FaInfoCircle size={18} className="me-2" /> About Us
            </Nav.Link>
            <Nav.Link as={NavLink} to="/fabrication" onClick={handleClose}>
              <FaIndustry size={18} className="me-2" /> Fabrication & Erection
            </Nav.Link>
            <Nav.Link as={NavLink} to="/security" onClick={handleClose}>
              <FaShieldAlt size={18} className="me-2" />Security & Housekeeping
            </Nav.Link>
            <Nav.Link as={NavLink} to="/manpowerservice" onClick={handleClose}>
              <FaUsersCog ciergeBell size={18} className="me-2" />Manpower Services
            </Nav.Link>
            <Nav.Link as={NavLink} to="/marklineservice" onClick={handleClose}>
              <MdFormatPaint size={18} className="me-2" />Mark Line Services
            </Nav.Link>
            <Nav.Link as={NavLink} to="/construction" onClick={handleClose}>
              <GiBrickWall size={18} className="me-2" /> Civil Construction
            </Nav.Link>
            <Nav.Link as={NavLink} to="/maintenance" onClick={handleClose}>
              <BiCalendarCheck  size={18} className="me-2" /> Routine Maintenance
            </Nav.Link>
             <Nav.Link as={NavLink} to="/teamandmachinery" onClick={handleClose}>
              <FaTools size={18} className="me-2" /> Team & Machineries 
            </Nav.Link>
             <Nav.Link as={NavLink} to="/KNGPage" onClick={handleClose}>
              <FaTools size={18} className="me-2" />   Nursery & Landscaping Services
            </Nav.Link>


            <Nav.Link as={NavLink} to="/contact" onClick={handleClose}>
              <FaPhoneAlt size={18} className="me-2" /> Contact Us
            </Nav.Link>
            
  
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>

    </>
  );
}

export default WebHeader;
